export const discoveryRouteDef = [
    {

    }
]


